/**
 * en-GB messages added by Phase 3 task S26 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s26EnGB = {
    'error.delivery_not_waiting': 'That parcel is no longer waiting to be collected.',
    'error.delivery_signature_required': 'A signature is needed to collect this parcel.',
    'error.delivery_time_before_logged': 'The collection time is before the parcel was logged.',
    'error.deliveries_courier_disabled': 'The courier flow is not switched on for this site.',
    'deliveries.carrier.unknown': 'a courier',
    'deliveries.location.reception': 'Reception',
};
//# sourceMappingURL=s26.js.map